import React, { ReactElement } from 'react';
import { useLocation, useParams } from 'react-router';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import Layout from '../../Layout';
import isPredbeznaInformacia from '../../../function/isPredbeznaInformacia';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import SecuredPage from '../../../module/SecuredPage';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import { ObalMaterialuNrSr } from '../../../module/SprievodnyDokument/CreateFromForm';
import { updateObalMaterialuNrSrClient } from '../../../client/external/evidencnaaplikacia/obalMaterialuNrSrClient';
import useObalMaterialuNrSrFormData from './hook/useObalMaterialuNrSrFormData';
import { useClient } from '../../../context/ClientStatusContext';
import {
  fetchObalMaterialuNrSrInitData,
} from '../../../client/pracovnyKrok/sprievodnyDokument/obalMaterialuInitDataClient';
import SuccessMessages from '../../../module/SuccessMessages';

const ObalMaterialuNrSrEditPage = (): ReactElement => {
  const location = useLocation();
  const {
    type,
    year: yearParam,
    index: indexParam,
    sprievodnyDokumentUuid,
    stadiumUuid,
  } = useParams();
  const year = parseInt(yearParam, 10);
  const index = parseInt(indexParam, 10);

  const {
    responseData,
    status,
  } = useObalMaterialuNrSrFormData(type, year, index, sprievodnyDokumentUuid);

  const {
    wrapClient: fillSystemDataClient,
    status: fillSystemDataStatus,
    data: fillSystemData,
  } = useClient(fetchObalMaterialuNrSrInitData);

  const {
    wrapClient: updateObalMaterialuNrSr,
    status: submitStatus,
  } = useClient(updateObalMaterialuNrSrClient);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia(type) ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia(type) ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Sprievodná dokumentácia',
          to: routes.procesy.detail.sprievodneDokumenty.edit.withParams(type, year, index),
        },
        {
          heading: 'Obal materiálu NR SR',
          to: location.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={status.loading}>
        {status.finished && (
          <SecuredPage
            hasOpravneniePracovneKroky={responseData.materialDetail?.hasOpravnenieSprievodneDokumenty}
            requestStatus={status.responseCode}
          >
            <>
              <SuccessMessages />
              {responseData?.materialDetail && responseData?.formData && (
                <>
                  <PageHeadingWithBackButton
                    headingCaption={`Legislatívny proces ${responseData.materialDetail.cisloLegislativnehoMaterialu}`}
                    heading="Obal materiálu NR SR"
                    withBackLink
                  />
                  <Loader loading={fillSystemDataStatus.loading}>
                    <ObalMaterialuNrSr
                      initFormData={fillSystemData || responseData.formData}
                      onSubmitForm={(formData) => updateObalMaterialuNrSr(
                        responseData.materialDetail.uuid,
                        formData,
                        sprievodnyDokumentUuid,
                        stadiumUuid,
                      )}
                      fillSystemDataStatus={fillSystemDataStatus}
                      fillSystemData={fillSystemData}
                      fillSystemDataClient={fillSystemDataClient}
                      submitStatus={submitStatus}
                    />
                  </Loader>
                </>
              )}
            </>
          </SecuredPage>
        )}
      </Loader>
    </Layout>
  );
};

export default ObalMaterialuNrSrEditPage;
